module.exports = {
    New_First_Charge_Event: "New_First_Charge"
};